export const getComponentDuro       = state =>  state.componentReducer.componentDuro
export const getActualComponentDuro = state =>  state.componentReducer.actualComponentDuro
export const getInputs              = state => state.componentReducer.inputs
export const getQueryParams         = state => state.oauthReducer.queryParams
